import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./Categories.scss";
import OrthoSection from "./OrthoSection/OrthoSection";
import GeneralSurgerySection from "./GeneralSurgerySection/GeneralSurgerySection";

const categories = [
  { id: "general-surgery", title: "General Surgery" },
  { id: "gynecology", title: "Gynecology" },
  { id: "orthopaedics", title: "Orthopaedics & Spine" },
  { id: "urology", title: "Urology" },
  { id: "pediatric", title: "Pediatric Surgery" },
  { id: "ureteroscopy", title: "Ureteroscopy" },
  { id: "cardiology", title: "Cardiology" },
  { id: "neurology", title: "Neurology" },
];

export default function CategoryDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const currentTitle =
    categories.find((c) => c.id === id)?.title ||
    id?.replace("-", " ");

  return (
    <div className="details-wrapper">

      {/* ---- Selected Treatment Dropdown ---- */}
      <div className="selected-treatment">
        <span>
          Selected Treatment : <strong>{currentTitle}</strong>
        </span>

        <div className="dropdown">
          <button onClick={() => setOpen(!open)}>
            Change ▼
          </button>

          {open && (
            <ul className="dropdown-menu">
              {categories.map((cat) => (
                <li
                  key={cat.id}
                  onClick={() => {
                    navigate(`/category/${cat.id}`);
                    setOpen(false);
                  }}
                >
                  {cat.title}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* ---- Page Content ---- */}
      <div className="details-content">

        {/* General Surgery */}
        {id === "general-surgery" && <GeneralSurgerySection />}

        {/* Orthopaedics */}
        {id === "orthopaedics" && <OrthoSection />}

        {/* Other categories */}
        {id !== "general-surgery" && id !== "orthopaedics" && (
          <>
            <h1>{currentTitle}</h1>
            <p>Design coming soon...</p>
          </>
        )}

      </div>
    </div>
  );
}

